export const SUPER_ADMIN_EMAIL = 'kairos@kairos.com';

export const ADMIN_EMAIL_ALLOWLIST = new Set([
  SUPER_ADMIN_EMAIL,
  'admin@kairos.com',
]);

export const ADMIN_PORTAL_ROLES = new Set([
  'admin',
  'administrator',
  'accountant',
  'ceo',
  'cfo',
  'staff',
]);

export const ACCOUNTING_MENU_PATHS = [
  '/',
  '/finance-settings',
  '/settlement-management',
  '/remittance-accounts',
];

export const ALL_ADMIN_MENU_PATHS = [
  '/',
  '/kyc',
  '/rcc-issuance',
  '/policy-compliance',
  '/notifications',
  '/notices',
  '/in-app-messaging',
  '/message-management',
  '/users',
  '/document-expiry-management',
  '/finance-settings',
  '/community-management',
  '/marketplace-management',
  '/consultation-faq-management',
  '/consultation-quota-monitor',
  '/gov-access',
  '/regional-poi-monitor',
  '/chat-cleanup',
  '/api-integration-monitoring',
  '/settlement-management',
  '/homepage-management',
  '/help',
  '/remittance-accounts',
];

export const getDefaultMenuPermissionsForRole = (role) => {
  if (role === 'accountant') {
    return [...ACCOUNTING_MENU_PATHS];
  }
  return [];
};

export const isSuperAdmin = (user) => {
  const email = String(user?.email || '').trim().toLowerCase();
  return email === SUPER_ADMIN_EMAIL || user?.customClaims?.superAdmin === true;
};

export const canAccessAdminPortal = (profile) => {
  if (!profile) return false;
  if (profile.admin === true) return true;
  return ADMIN_PORTAL_ROLES.has(profile.role);
};

export const hasMenuPermission = (user, profile, menuPath) => {
  if (isSuperAdmin(user)) return true;
  if (menuPath === '/permissions') return false;

  const explicitPermissions = Array.isArray(profile?.menuPermissions) ? profile.menuPermissions : [];
  if (explicitPermissions.length > 0) {
    return explicitPermissions.includes(menuPath);
  }

  const roleDefaults = getDefaultMenuPermissionsForRole(profile?.role);
  if (roleDefaults.length > 0) {
    return roleDefaults.includes(menuPath);
  }

  if (profile?.role === 'admin' || profile?.role === 'administrator' || profile?.admin === true) {
    return ALL_ADMIN_MENU_PATHS.includes(menuPath);
  }

  return false;
};

export const validateAdminPassword = (password) => {
  const value = String(password || '').trim();
  if (value.length < 8) {
    return '비밀번호는 8자 이상이어야 합니다.';
  }
  if (!/[A-Za-z]/.test(value) || !/[0-9]/.test(value)) {
    return '비밀번호는 영문과 숫자를 각각 1자 이상 포함해야 합니다.';
  }
  return '';
};
